import request from '../utils/request';

//售后列表
export async function getReward() {
  return await request('data/rpbase', 'get');
}
export async function putReward(enable, start, end) {
  return await request(`data/rpbase?enable=${enable}&start=${start}&end=${end}`, 'put');
}
